/* Dispatch line.
 *
 * The page ships with a statement that is always true ("Ships same day, Mon-Fri
 * before 1pm PST") because Shopify caches pages and because LLM crawlers record
 * whatever the HTML says. Promising "ships today" server-side means a page
 * cached on Friday afternoon tells a Saturday shopper the wrong thing.
 *
 * Here, in a browser with a real clock, we can be specific. Everything is
 * computed in America/Los_Angeles rather than the visitor's own timezone: the
 * cutoff is a fact about the warehouse, not about where the shopper is. Using
 * Intl also means DST is handled, so this keeps working when PST becomes PDT.
 */
(function () {
  var CUTOFF_FALLBACK = 13; // 1pm

  function warehouseNow() {
    // Read the wall-clock weekday and hour in the warehouse's timezone.
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'short',
      hour: 'numeric',
      hour12: false
    }).formatToParts(new Date());
    var out = {};
    parts.forEach(function (p) { out[p.type] = p.value; });
    var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: days[out.weekday], hour: parseInt(out.hour, 10) % 24 };
  }

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function nextDispatchDay(day, hour, cutoff) {
    // Monday to Friday, before the cutoff: it goes out today.
    if (day >= 1 && day <= 5 && hour < cutoff) return { when: 'today' };
    // Otherwise find the next weekday.
    var d = day;
    for (var i = 1; i <= 7; i++) {
      d = (day + i) % 7;
      if (d >= 1 && d <= 5) break;
    }
    // On a weekend, always name the day. "Ships tomorrow" is literally true on
    // a Sunday but reads as though the warehouse is open, which is the
    // confusion this whole change exists to remove.
    if (day === 0 || day === 6) return { when: 'later', name: DAY_NAMES[d] };
    // Midweek, "tomorrow" is friendlier, but only when it really is the next
    // calendar day — after Friday's cutoff the next weekday is three days out.
    if (d === (day + 1) % 7) return { when: 'tomorrow', name: DAY_NAMES[d] };
    return { when: 'later', name: DAY_NAMES[d] };
  }

  function apply(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoff)) cutoff = CUTOFF_FALLBACK;
    var now = warehouseNow();
    if (isNaN(now.day) || isNaN(now.hour)) return; // leave the safe text alone
    var next = nextDispatchDay(now.day, now.hour, cutoff);
    var text;
    if (next.when === 'today') {
      text = el.getAttribute('data-today');
    } else if (next.when === 'tomorrow') {
      text = el.getAttribute('data-tomorrow');
    } else {
      text = el.getAttribute('data-nextday');
    }
    if (!text) return;
    el.textContent = text.replace('{day}', next.name || '');
  }

  function run() {
    var els = document.querySelectorAll('[data-dispatch]');
    for (var i = 0; i < els.length; i++) apply(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
